import React from "react";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AddBrandModalFooterProps {
  onClose: () => void;
  isSubmitDisabled: boolean;
  isPending: boolean;
}

export const AddBrandModalFooter: React.FC<AddBrandModalFooterProps> = ({
  onClose,
  isSubmitDisabled,
  isPending,
}) => {
  return (
    <div className="p-5 px-6 border-t border-slate-100 bg-slate-50/40 flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="flex items-center gap-2 text-xs text-slate-500">
        <ShieldCheck className="w-4 h-4 text-[#A655F8] shrink-0" />
        <span>Your data is secure and will only be used to create this brand.</span>
      </div>

      <div className="flex items-center gap-2.5 w-full sm:w-auto justify-end">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          className="h-10 px-5 rounded-xl border-slate-200 text-slate-700 hover:bg-slate-100 hover:text-slate-900 shadow-none font-medium text-sm"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          disabled={isSubmitDisabled}
          className="h-10 px-6 rounded-xl bg-[#A655F8] hover:bg-[#9333EA] text-white shadow-none font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isPending ? "Adding..." : "Add Brand"}
        </Button>
      </div>
    </div>
  );
};
